import React from 'react';
import './DigitalGaitSection.css';

const DigitalGaitSection = () => {
    return (
        <div className="digital-gait-section">
            <div className="content">
                <h2>Reliable Digital Gait<br/>Treatment and Management</h2>
                <p>Keep track of your child’s progress anywhere, anytime.</p>
                <p>Measure user’s gait health via our sensors infused smart insoles.</p>
                <p>Gamified treatment exercises for kids to improve musculoskeletal habits.</p>
                <button className="how-it-works">How it works</button>
            </div>
            <img className="gait-image" src="/Images/shoe layer.png" alt="Gait Management" />
        </div>
    );
};

export default DigitalGaitSection;